import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	editOption: {
		id: 'issue-field-single-select-editview-full.single-select.edit-option',
		defaultMessage: 'Edit option {optionName}',
		description: 'Label for the edit option button',
	},
});
